import gql from 'graphql-tag';

export const markAsResolvedMutation = gql`
    mutation markAsResolved ($chatId: String!){
        markAsResolved(chatId: $chatId)
    }
`;
